import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($id: Int!, $project_id: String!){
  removeProjectExpense(id: $id, project_id: $project_id){
    ${projectFragment}
  }
}`